export enum AnalyticsChartPeriods {
    Daily = '1day',
    Weekly = '1week',
    Monthly = '1month'
}